import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/layouts/default.vue").then(m => m.default || m))
}